(function () {
  'use strict';

  const desktopPointer = window.matchMedia('(min-width: 1008px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency', currency: currency || 'BRL'
    }).format(cents / 100);
  }

  function visibleCurrency(baseCurrency) {
    const converterCurrency = window.Currency && window.Currency.currentCurrency;
    return converterCurrency || baseCurrency;
  }

  function selectedVariant(section) {
    const json = section.querySelector('[data-product-json]');
    if (!json) return null;
    try {
      const data = JSON.parse(json.textContent);
      const input = section.querySelector('.ProductForm [name="id"]');
      const selectedId = input ? input.value : data.selected_variant_id;
      return data.product.variants.find(variant => String(variant.id) === String(selectedId)) || null;
    } catch (error) {
      return null;
    }
  }

  function updatePayment(section, variant) {
    const payment = section.querySelector('[data-louford-payment]');
    if (!payment) return;
    const baseCurrency = payment.dataset.currency || 'BRL';
    const currentCurrency = visibleCurrency(baseCurrency);
    const installments = payment.querySelector('[data-louford-installments]');
    const pix = payment.querySelector('[data-louford-pix]');
    if (pix) pix.hidden = !variant || currentCurrency !== 'BRL' || baseCurrency !== 'BRL';
    if (installments) installments.hidden = !variant || currentCurrency !== baseCurrency;
    const nativePrices = payment.querySelector('.ProductMeta__PriceList');
    const usePix = currentCurrency === 'BRL' && baseCurrency === 'BRL';
    payment.classList.toggle('LoufordPayment--pix', usePix);
    if (nativePrices) nativePrices.hidden = usePix;
    const compare = payment.querySelector('[data-louford-compare]');
    if (compare) { compare.hidden = !usePix || !variant || variant.compare_at_price <= variant.price; if (variant) compare.textContent = money(variant.compare_at_price, baseCurrency); }
    if (variant) {
      const pixAmount = payment.querySelector('[data-louford-pix-amount]');
      const installmentAmount = payment.querySelector('[data-louford-installment-amount]');
      if (pixAmount) pixAmount.textContent = money(Math.round(variant.price * 0.95), baseCurrency);
      if (installmentAmount) {
        installmentAmount.textContent = money(Math.round(variant.price / 3), baseCurrency);
        installmentAmount.removeAttribute('data-currency-' + baseCurrency.toLowerCase());
      }
    }
  }

  function initGallery(section) {
    const slideshow = section.querySelector('.Product__Slideshow');
    if (!slideshow || slideshow.dataset.loufordGallery) return;
    slideshow.dataset.loufordGallery = 'true';
    const slides = Array.from(slideshow.querySelectorAll('.Product__SlideItem'));
    const links = Array.from(section.querySelectorAll('.Product__SlideshowNav a[href^="#Image"]'));
    const galleryImages = slides.map(slide => slide.querySelector('[data-louford-gallery-image]')).filter(Boolean);
    const primaryImage = slides.find(slide => slide.classList.contains('is-selected'))?.querySelector('[data-louford-gallery-image]') || galleryImages[0];
    async function decodeImage(image) {
      if (!image) return;
      try {
        if (typeof image.decode === 'function') await image.decode();
        else if (!image.complete) await new Promise(resolve => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
        if (image.complete && image.naturalWidth > 0) image.dataset.loufordGalleryReady = 'true';
      } catch (error) {}
    }
    decodeImage(primaryImage).then(() => {
      const pendingImages = galleryImages.filter(image => image !== primaryImage);
      async function decodeNext() {
        while (pendingImages.length && slideshow.isConnected) await decodeImage(pendingImages.shift());
      }
      return Promise.all([decodeNext(), decodeNext()]);
    });
    let boundInstance = null;
    let pointerX = null;
    let revealedImageId = null;
    function instance() { return window.Flickity && window.Flickity.data(slideshow); }
    function direction(clientX) {
      const carousel = instance();
      if (!desktopPointer.matches || !carousel || slides.length < 2 || !carousel.selectedElement?.classList.contains('Product__SlideItem--image')) return null;
      const bounds = slideshow.getBoundingClientRect();
      const step = clientX - bounds.left < bounds.width / 2 ? -1 : 1;
      const nextIndex = carousel.selectedIndex + step;
      return nextIndex >= 0 && nextIndex < slides.length ? step : null;
    }
    function updateCursor() {
      const step = pointerX === null ? null : direction(pointerX);
      if (step) slideshow.dataset.loufordCursor = step < 0 ? 'prev' : 'next';
      else delete slideshow.dataset.loufordCursor;
    }
    function sync() {
      const carousel = instance();
      const current = carousel && carousel.selectedElement;
      if (!current) return;
      links.forEach(link => {
        const active = link.hash === '#' + current.id;
        link.classList.toggle('is-selected', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (revealedImageId !== current.id) {
        const activeThumbnail = links.find(link => link.hash === '#' + current.id && link.classList.contains('Product__SlideshowNavImage'));
        const scroller = activeThumbnail?.closest('.Product__SlideshowNavScroller');
        if (scroller) {
          const bounds = scroller.getBoundingClientRect();
          const thumbnail = activeThumbnail.getBoundingClientRect();
          const horizontal = window.matchMedia('(max-width: 1007px)').matches;
          const delta = horizontal
            ? thumbnail.left < bounds.left ? thumbnail.left - bounds.left : thumbnail.right > bounds.right ? thumbnail.right - bounds.right : 0
            : thumbnail.top < bounds.top ? thumbnail.top - bounds.top : thumbnail.bottom > bounds.bottom ? thumbnail.bottom - bounds.bottom : 0;
          if (delta) scroller.scrollTo({
            left: horizontal ? scroller.scrollLeft + delta : scroller.scrollLeft,
            top: horizontal ? scroller.scrollTop : scroller.scrollTop + delta,
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        }
        revealedImageId = current.id;
      }
      updateCursor();
    }
    function select(index) {
      const carousel = instance();
      if (!carousel || !carousel.isActive) return false;
      carousel.select(Math.max(0, Math.min(index, slides.length - 1)), false, true);
      sync();
      return true;
    }
    function bind() {
      const carousel = instance();
      if (!carousel || carousel === boundInstance) return;
      if (boundInstance) boundInstance.off('select', sync);
      boundInstance = carousel;
      carousel.options.watchCSS = false;
      if (!carousel.isActive) carousel.activate();
      carousel.on('select', sync);
      carousel.resize();
      sync();
    }
    slideshow.addEventListener('pointermove', event => {
      pointerX = event.pointerType === 'mouse' ? event.clientX : null;
      updateCursor();
    }, { passive: true });
    slideshow.addEventListener('pointerleave', () => {
      pointerX = null;
      updateCursor();
    }, { passive: true });
    slideshow.addEventListener('click', event => {
      if (!desktopPointer.matches || event.button !== 0 || event.detail === 0 || event.pointerType === 'touch' || !event.target.closest('.Product__SlideItem--image') || event.target.closest('a, button')) return;
      const carousel = instance();
      if (!carousel || slides.length < 2) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (carousel.isPreventingClicks) return;
      const step = direction(event.clientX);
      if (step) select(carousel.selectedIndex + step);
    }, true);
    slideshow.addEventListener('keydown', event => {
      if (event.target !== slideshow || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const carousel = instance();
      if (!carousel || slides.length < 2) return;
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : carousel.selectedIndex + (event.key === 'ArrowLeft' ? -1 : 1);
      if (select(index)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    links.forEach(link => link.addEventListener('click', event => {
      const index = slides.findIndex(slide => '#' + slide.id === link.hash);
      if (index >= 0 && select(index)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true));
    document.addEventListener('breakpoint:changed', () => {
      revealedImageId = null;
      requestAnimationFrame(() => { bind(); sync(); });
      updateCursor();
    });
    desktopPointer.addEventListener('change', updateCursor);
    bind();
    window.addEventListener('load', bind, { once: true });
  }

  function initModelDetails(section) {
    const table = section.querySelector('[data-louford-specifications] table');
    const care = section.querySelector('[data-louford-care-text]');
    if (!table || !care) return;
    const value = pattern => Array.from(table.rows).find(item => pattern.test(item.cells[0]?.textContent || ''))?.cells[1]?.textContent.trim() || '';
    const maintenance = value(/manuten|cuidados|limpeza/i);
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const material = normalize(value(/material externo/i));
    const instruction = normalize(maintenance);
    if (material.includes('camurca') || /limp(?:ar|eza) a seco/.test(instruction)) {
      care.textContent = care.dataset.careSuede;
    } else if (material.includes('lona') || instruction.includes('sabao neutro')) {
      care.textContent = care.dataset.careCanvas;
    } else if (instruction.includes('hidratante')) {
      care.textContent = instruction.includes('pano umido') ? care.dataset.careDampLeather : care.dataset.careLeather;
    } else if (maintenance) {
      care.textContent = maintenance;
    }
  }

  function deliveryBaseDate(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(now);
    const value = type => Number(parts.find(part => part.type === type).value);
    return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
  }

  function isDeliveryBusinessDay(date) {
    if (date.getUTCDay() === 0 || date.getUTCDay() === 6) return false;
    const monthDay = (date.getUTCMonth() + 1) + '-' + date.getUTCDate();
    if (['1-1', '4-21', '5-1', '9-7', '10-12', '11-2', '11-15', '11-20', '12-25'].includes(monthDay)) return false;
    const year = date.getUTCFullYear();
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = (h + l - 7 * m + 114) % 31 + 1;
    const goodFriday = new Date(Date.UTC(year, month - 1, day - 2, 12));
    return date.getUTCMonth() !== goodFriday.getUTCMonth() || date.getUTCDate() !== goodFriday.getUTCDate();
  }

  function addDeliveryBusinessDays(base, count) {
    const date = new Date(base);
    let remaining = count;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isDeliveryBusinessDay(date)) remaining -= 1;
    }
    return date;
  }

  function deliveryDateRange(base, minimum, maximum, template) {
    const start = addDeliveryBusinessDays(base, minimum), end = addDeliveryBusinessDays(base, maximum);
    const options = { timeZone: 'UTC', day: '2-digit', month: '2-digit' };
    if (start.getUTCFullYear() !== base.getUTCFullYear() || end.getUTCFullYear() !== base.getUTCFullYear()) options.year = 'numeric';
    const format = new Intl.DateTimeFormat('pt-BR', options);
    return template.replace('__start__', format.format(start)).replace('__end__', format.format(end));
  }

  function initDelivery(section) {
    const delivery = section.querySelector('[data-louford-delivery]');
    if (!delivery || delivery.dataset.initialized) return;
    delivery.dataset.initialized = 'true';
    const form = delivery.querySelector('form');
    const input = form.querySelector('input');
    const button = form.querySelector('button');
    const status = delivery.querySelector('[data-louford-delivery-status]');
    const result = delivery.querySelector('[data-louford-delivery-result]');
    let request = null;
    input.addEventListener('input', () => {
      const digits = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
      input.removeAttribute('aria-invalid');
      status.textContent = '';
      result.hidden = true;
      if (request) {
        request.abort();
        request = null;
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
    input.addEventListener('invalid', () => {
      status.textContent = delivery.dataset.invalid;
      input.setAttribute('aria-invalid', 'true');
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const postcode = input.value.replace(/\D/g, '');
      result.hidden = true;
      if (postcode.length !== 8) {
        status.textContent = delivery.dataset.invalid;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      if (request) request.abort();
      const controller = new AbortController();
      request = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      status.textContent = delivery.dataset.loading;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch('https://viacep.com.br/ws/' + postcode + '/json/', { signal: controller.signal });
        if (!response.ok) throw new Error('postcode');
        const destination = await response.json();
        if (controller !== request) return;
        if (destination.erro || !destination.localidade || !destination.uf) {
          status.textContent = delivery.dataset.notFound;
          input.setAttribute('aria-invalid', 'true');
          return;
        }
        delivery.querySelector('[data-louford-delivery-city]').textContent = destination.localidade + ' / ' + destination.uf;
        const baseDate = deliveryBaseDate();
        delivery.querySelector('[data-louford-delivery-economic]').textContent = deliveryDateRange(baseDate, 3, 9, delivery.dataset.dateRange);
        delivery.querySelector('[data-louford-delivery-express]').textContent = deliveryDateRange(baseDate, 2, 7, delivery.dataset.dateRange);
        status.textContent = '';
        result.hidden = false;
      } catch (error) {
        if (controller === request) status.textContent = delivery.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (controller === request) {
          button.disabled = false;
          form.removeAttribute('aria-busy');
          request = null;
        }
      }
    });
  }

  function initSection(section) {
    if (section.dataset.loufordProduct) return;
    section.dataset.loufordProduct = 'true';
    updatePayment(section, selectedVariant(section));
    section.addEventListener('variant:changed', event => updatePayment(section, event.detail.variant));
    section.addEventListener('product:added', () => {
      const status = section.querySelector('[data-louford-product-status]');
      if (status) status.textContent = status.dataset.added;
    });
    ['currency:changed', 'currency:change'].forEach(name => document.addEventListener(name, () => updatePayment(section, selectedVariant(section))));
    initGallery(section);
    initDelivery(section);
    initModelDetails(section);
  }

  function boot(root) {
    root.querySelectorAll('[data-section-type="product"]').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target.parentElement));
})();
